/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from "@msdyn365-commerce/core";

/**
 * BritaxGetSearchSuggestion Input Action
 */
var productList: any;
export class BritaxGetSearchSuggestionInput implements Msdyn365.IActionInput {
  // TODO: Construct the input needed to run the action
  constructor(productName: any) {
    productList = productName;
  }

  // TODO: Determine if the results of this get action should cache the results and if so provide
  // a cache object type and an appropriate cache key
  public getCacheKey = () => `TODO`;
  public getCacheObjectType = () => "TODO";
  public dataCacheType = (): Msdyn365.CacheType => "none";
}

export interface Value3 {
  BooleanValue?: any;
  ByteValue?: any;
  DateTimeOffsetValue?: any;
  DecimalValue?: any;
  IntegerValue?: number;
  LongValue?: any;
  StringValue: string;
}

export interface Value2 {
  Key: string;
  Value: Value3;
}

export interface Value4 {
  BooleanValue?: any;
  ByteValue?: any;
  DateTimeOffsetValue?: any;
  DecimalValue?: number;
  IntegerValue?: number;
  LongValue?: any;
  StringValue?: any;
}

export interface Value32 {
  Key: string;
  Value: Value4;
}

export interface Value5 {
  BooleanValue?: any;
  ByteValue?: any;
  DateTimeOffsetValue?: any;
  DecimalValue: number;
  IntegerValue?: any;
  LongValue?: any;
  StringValue?: any;
}

export interface Value42 {
  Key: string;
  Value: Value5;
}

export interface Value {
  Value: string;
  Value2: Value2;
  Value3: Value32;
  Value4: Value42;
  SuggestionType: string;
  Id: string;
  ImageUrl: string;
  ExtensionProperties: any[];
}

export interface RootProducts {
  context: string;
  value: Value[];
}
// TODO: Create a data model here or import one to capture the response of the action
export interface IBritaxGetSearchSuggestionData {
  text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
  args: Msdyn365.ICreateActionContext
): Msdyn365.IActionInput => {
  return new BritaxGetSearchSuggestionInput("");
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(
  input: BritaxGetSearchSuggestionInput,
  ctx: Msdyn365.IActionContext
): Promise<RootProducts> {
  // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
  // TODO: Uncomment the below line to get the value from a service
  var data =
    '{"searchSuggestionCriteria":{"ProductSearchCriteria":{"SearchCondition":"' +
    productList +
    '","Context":{"ChannelId":' +
    ctx.requestContext.apiSettings.channelId +
    ',"CatalogId":' +
    ctx.requestContext.user.catalogId +
    '}},"HitPrefix":"{","HitSuffix":"}","SuggestionType":"Keyword, Product, ScopedCategory"}}';
  const response = await Msdyn365.sendRequest<RootProducts>(
    ctx.requestContext.apiSettings.baseUrl +
      "/Commerce/GetSearchSuggestions?$top=5&api-version=7.3",
    "post",
    data,
    {
      headers: {
        pragma: "no-cache",
        "cache-control": "no-cache",
        "sec-ch-ua":
          '"Google Chrome";v="93", " Not;A Brand";v="99", "Chromium";v="93"',
        "accept-language": "en-us",
        authorization: "id_token " + ctx.requestContext.user.token,
        "from-keystone": "true",
        requestid: "79fcb59d28907b4a9e8f9fbcd43e44d3/2",
        usersessionid: "Ssxzd",
        contenttype: "application/json",
        oun: ctx.requestContext.apiSettings.oun,
        "sec-ch-ua-platform": '"Windows"',
        "odata-version": "4.0",
        prefer: "return=representation",
        "sec-ch-ua-mobile": "?0",
        "user-agent":
          "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/93.0.4577.63 Safari/537.36",
        "content-type": "application/json;charset=UTF-8",
        accept: "application/json",
        appsessionid: "QPOwtjMgTBN6yfOWBUKJ/l",
        "odata-maxversion": "4.0",
        origin: "https://britax-sandbox.commerce.dynamics.com",
        "sec-fetch-site": "same-site",
        "sec-fetch-mode": "cors",
        "sec-fetch-dest": "empty",
        referer: "https://britax-sandbox.commerce.dynamics.com/",
      },
    }
  );
  return response.data;
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<RootProducts>>action,
  // TODO: Give your data action a unique id
  id: "BritaxGetSearchSuggestion",
  input: createInput,
  // TODO: Uncomment the below line if this is a meant to be a batched data action
  // isBatched: true
});
